type ReviewTextForDisplayInput = {
    text: string | null | undefined;
    pros: string | null | undefined;
    cons: string | null | undefined;
    bables?: string[] | null | undefined;
    orderStatus?: string | null | undefined;
};

type ReviewTextForDisplayOptions = {
    prosConsOnNewLines?: boolean;
    prosLabel?: string;
    consLabel?: string;
    includeOrderStatus?: boolean;
    orderStatusLabel?: string;
};

export const DEFAULT_PROS_LABEL = 'Нравится';
export const DEFAULT_CONS_LABEL = 'Недостатки';
export const DEFAULT_ORDER_STATUS_LABEL = 'статус';

const ORDER_STATUS_DISPLAY_BY_VALUE: Record<string, string> = {
    buyout: 'Выкуп',
    rejected: 'Отказ',
    returned: 'Возврат',
};

const normalizeText = (value: string | null | undefined): string => {
    if (typeof value !== 'string') {
        return '';
    }

    return value.replaceAll('\\n', '\n').trim();
};

const normalizeBables = (value: string[] | null | undefined): string[] => {
    if (!Array.isArray(value)) {
        return [];
    }

    return value.map((bable) => normalizeText(bable)).filter(Boolean);
};

const buildTextValue = (text: string, bables: string[]): string => {
    const textParts = [text, ...bables].filter(Boolean);
    return textParts.join('; ');
};

export const formatReviewOrderStatusForDisplay = (value: string | null | undefined): string | null => {
    const normalizedValue = normalizeText(value).toLowerCase();
    return ORDER_STATUS_DISPLAY_BY_VALUE[normalizedValue] || null;
};

export const formatReviewTextForDisplay = (
    { text, pros, cons, bables, orderStatus }: ReviewTextForDisplayInput,
    options: ReviewTextForDisplayOptions = {},
): string => {
    const prosLabel = options.prosLabel ?? DEFAULT_PROS_LABEL;
    const consLabel = options.consLabel ?? DEFAULT_CONS_LABEL;
    const orderStatusLabel = options.orderStatusLabel ?? DEFAULT_ORDER_STATUS_LABEL;
    const includeOrderStatus = options.includeOrderStatus ?? true;
    const normalizedText = buildTextValue(normalizeText(text), normalizeBables(bables));
    const normalizedPros = normalizeText(pros);
    const normalizedCons = normalizeText(cons);
    const prosConsParts: string[] = [];

    if (normalizedPros) {
        prosConsParts.push(`${prosLabel}: ${normalizedPros}`);
    }

    if (normalizedCons) {
        prosConsParts.push(`${consLabel}: ${normalizedCons}`);
    }

    const orderStatusDisplay = includeOrderStatus ? formatReviewOrderStatusForDisplay(orderStatus) : null;
    if (orderStatusDisplay) {
        prosConsParts.push(`${orderStatusLabel}: ${orderStatusDisplay}`);
    }

    if (!prosConsParts.length) {
        return normalizedText;
    }

    const separator = options.prosConsOnNewLines ? '\n' : ' ';
    const prosAndCons = prosConsParts.join(separator);

    if (!normalizedText) {
        return prosAndCons;
    }

    return `${normalizedText}${separator}${prosAndCons}`;
};
